import React from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {IconButton} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import EventIcon from 'Components/common/Icons/EventIcon';

const InfoCard = ({
    backgroundColor,
    bottomText,
    className,
    distance,
    hasEvents,
    iconUrl,
    imageUrl,
    onClick,
    size,
    textColour,
    title,
    topText,
    topTextColour,
}) => {
    const useStyles = makeStyles(() => ({
        detailButton: {
            color: textColour || '#1ba9ce',
        },
        icon: {
            fontSize: 16,
        },
    }));
    const classes = useStyles();

    return (
        <div
            className={classNames('info-card', className, {
                'info-card-lg': size === 'large',
                'info-card-sm': size === 'small',
            })}
            onClick={onClick}
            style={{backgroundColor, color: textColour}}
        >
            {hasEvents && (
                <div className="info-card-badge info-card-badge-experience">
                    <EventIcon />
                </div>
            )}
            {imageUrl && (
                <div className="info-card-img" style={{backgroundImage: `url('${imageUrl}')`}} />
            )}
            {!imageUrl &&
                iconUrl && (
                    <div className="info-card-icon">
                        <img
                            alt="icon"
                            src={iconUrl}
                            style={{
                                height: 'auto',
                                maxHeight: 48,
                                minWidth: 48,
                                maxWidth: 96,
                                width: 'auto',
                            }}
                        />
                    </div>
                )}
            <div className="card-body" style={{backgroundColor, color: textColour}}>
                {distance && <div className="top-right">{distance}</div>}
                {topText && (
                    <h6
                        className="info-card-top-text trim-text"
                        data-testid="info-card-top-text"
                        style={{color: topTextColour}}
                    >
                        {topText}
                    </h6>
                )}
                <h3
                    data-testid="info-card-title"
                    className={classNames('title', 'trim-text')}
                    style={{color: textColour}}
                >
                    {title}
                </h3>
                {bottomText && (
                    <p
                        data-testid="info-card-bottom-text"
                        className={classNames('card-bottom-text', 'trim-text')}
                    >
                        {bottomText}
                    </p>
                )}
                <IconButton
                    data-testid="info-card-bottom-button"
                    classes={{root: classes.detailButton}}
                    className="card-details-button"
                >
                    <ArrowForwardIosIcon
                        classes={{fontSizeSmall: classes.icon}}
                        fontSize="small"
                        style={{color: textColour}}
                    />
                </IconButton>
            </div>
        </div>
    );
};

InfoCard.defaultProps = {
    backgroundColor: '',
    textColour: '',
};

InfoCard.propTypes = {
    backgroundColor: PropTypes.string,
    bottomText: PropTypes.string,
    className: PropTypes.string,
    distance: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    hasEvents: PropTypes.bool,
    iconUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    size: PropTypes.oneOf(['large', 'regular', 'small']),
    textColour: PropTypes.string,
    title: PropTypes.string.isRequired,
    topText: PropTypes.string,
    topTextColour: PropTypes.string,
};

export default InfoCard;
